import React from "react";
import { Breadcrumbs } from "components/navigation/Breadcrumbs";
import PropTypes from "prop-types";
import { Route, Routes } from "react-router-dom";
import { VerticalLinkGroup } from "components/navigation";
import { ResellerGeneralSettings } from "./general";

export function ResellerSettings({ breadcrumbs }) {
    let routes = [
        {
            location: "/reseller/settings",
            title: "Theme",
        }
    ];

    return (
        <div>
            <div className="row">
                <Breadcrumbs items={breadcrumbs} />
                <h1>Reseller Settings</h1> {/* Placeholder content, will change in future pbi */}
            </div>
            <div className="layout-cols">
                <div className="col side-col">
                    <div className="row">
                        <VerticalLinkGroup links={routes} exactRouteMatch={false}></VerticalLinkGroup>
                    </div>
                </div>
                <div className="col content-col">
                    <Routes>
                        <Route path="" element={<ResellerGeneralSettings />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

ResellerSettings.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
};
